'use strict';
// ============================================
// GLOBAL FUNCTIONS (outside DOMContentLoaded)
// ============================================

function toggleShipBox() {
  const box = document.getElementById("shipBox");
  const icon = document.getElementById("shipToggle");
  if (box.style.display === "block") {
    box.style.display = "none";
    icon.innerHTML = "+";
  } else {
    box.style.display = "block";
    icon.innerHTML = "−";
  }
}

function getShippingRates() {
  const country = document.getElementById("shipCountry").value;
  const state = document.getElementById("shipState").value;
  const zip = document.getElementById("shipZip").value.trim();
  const resultBox = document.getElementById("shippingResult");
  const freeBar = document.getElementById("freeShipBar");
  const freeMsg = document.getElementById("freeShipMsg");

  freeBar.style.display = "none";
  freeMsg.style.display = "none";

  if (!zip || !state) {
    resultBox.innerHTML = "Please enter state and pincode";
    return;
  }
  if (!/^[1-9][0-9]{5}$/.test(zip)) {
    resultBox.innerHTML = `<span style="color:red;">Error: Enter a valid 6 digit PIN code</span>`;
    return;
  }

  resultBox.innerHTML = "Calculating...";

  fetch(`/cart/shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${state}`)
    .then(res => res.json())
    .then(data => {
      if (data.errors) {
        const msg = data.errors.zip ? data.errors.zip[0] : `Enter a valid PIN code for ${state}, India.`;
        resultBox.innerHTML = `<span style="color:red;">Error: ${msg}</span>`;
        return;
      }
      if (!data.shipping_rates || data.shipping_rates.length === 0) {
        resultBox.innerHTML = `<span style="color:red;">Error: Enter a valid PIN code for ${state}, India.</span>`;
        return;
      }
      let html = `<b>Available shipping carriers :</b><br>`;
      let hasFreeShipping = false;
      data.shipping_rates.forEach(rate => {
        const price = (rate.price / 100).toFixed(2);
        if (rate.price == 0) hasFreeShipping = true;
        html += `- ${rate.name} : ₹${price}<br>`;
      });
      resultBox.innerHTML = html;
      if (hasFreeShipping) {
        freeBar.style.display = "block";
        freeMsg.style.display = "flex";
      }
    })
    .catch(() => {
      resultBox.innerHTML = `<span style="color:red;">Error: Enter a valid PIN code for ${state}, India.</span>`;
    });
}

// ============================================
// SINGLE DOMContentLoaded — ALL MERGED HERE
// ============================================

document.addEventListener("DOMContentLoaded", function () {

  // ── 1. Product Title Highlight ──────────────────
  const titleEl = document.querySelector('.product__title');
  if (titleEl) {
    titleEl.innerHTML = titleEl.innerHTML.replace(
      /2400\s*VA/g,
      '<span class="highlight-va">$&</span>'
    );
  }

  // ── 2. Custom Tabs ──────────────────────────────
  document.querySelectorAll('.custom-tabs-wrapper').forEach(wrapper => {
    const tabs = wrapper.querySelectorAll('.custom-tab-item');
    const panes = wrapper.querySelectorAll('.custom-tab-pane');
    tabs.forEach(tab => {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        tabs.forEach(t => t.classList.remove('active'));
        panes.forEach(p => p.classList.remove('active'));
        tab.classList.add('active');
        const targetPane = wrapper.querySelector(tab.querySelector('.custom-tab-link').getAttribute('href'));
        if (targetPane) targetPane.classList.add('active');
      });
    });
  });

  // ── 3. Number Animation ─────────────────────────
  document.querySelectorAll('.video-with-text-genus').forEach(section => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        const el = entry.target;
        if (el.dataset.animated) return;
        const fullText = el.textContent.trim();
        const numberMatch = fullText.match(/\d+/);
        if (!numberMatch) return;
        const prefix = fullText.split(numberMatch[0])[0] || '';
        const suffix = fullText.split(numberMatch[0])[1] || '';
        const targetNumber = parseInt(numberMatch[0]);
        el.textContent = '';
        const span = document.createElement('span');
        el.appendChild(document.createTextNode(prefix));
        el.appendChild(span);
        el.appendChild(document.createTextNode(suffix));
        el.classList.add('visible');
        let current = 0;
        const totalFrames = Math.round(2000 / (1000 / 30));
        const increment = targetNumber / totalFrames;
        const counter = setInterval(() => {
          current += increment;
          if (current >= targetNumber) { current = targetNumber; clearInterval(counter); }
          span.textContent = Math.floor(current);
        }, 1000 / 30);
        el.dataset.animated = true;
      });
    }, { threshold: 0.5 });
    section.querySelectorAll('.animated-number').forEach(num => observer.observe(num));
  });

  // ── 4. Heading Line Animation ───────────────────
  const animatedTitles = document.querySelectorAll(".title-wrapper h2, .career__title h2, .cms-why-choose h2, .cms-rich-text h2, .banner__content .collection-img-title.animate, .leadership-group-photo .title-wrapper-with-link h2.animate, .collection-list-title, .image-text-section .content-heading span:first-child, .blog__title, .heading-faq h2, .faq-left h2, .image-with-text__heading, .product-icon-text h2, .achievements-heading, .mission-vision-content h2, .innovation-rd-title, .contact-info__heading, .recently-viewed__title, .template-suffix-contact .banner__content .banner__heading, #shopify-section-template--18961349640237__video_carousel_d7U9dY .heading-row h2, .customer.register h1, .customer.login h1, .template-search__header h1, .feature-job .multicolumn__title h2");
  const titleObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("animate");
      } else {
        entry.target.classList.remove("animate");
      }
    });
  }, { threshold: 0.6 });
  animatedTitles.forEach(el => titleObserver.observe(el));

  // ── 5. Buy Button Rename ────────────────────────
  function renameFeaturedBuyButton() {
    document.querySelectorAll('.featured-product').forEach(section => {
      section.querySelectorAll('button, input[type="submit"]').forEach(btn => {
        if (btn.textContent.trim().toLowerCase() === 'buy it now') {
          btn.textContent = 'Buy Now';
          btn.setAttribute('aria-label', 'Buy Now');
        }
      });
    });
    setTimeout(renameFeaturedBuyButton, 400);
  }
  renameFeaturedBuyButton();

  // ── 6. Collection List Dots ─────────────────────
  document.querySelectorAll('.collection-list-wrapper ul[id^="Slider-"]').forEach(sliderUL => {
    const sectionRoot = sliderUL.closest('.collection-list-wrapper');
    const sliderWrapper = sliderUL.closest('.slider');
    if (!sectionRoot || !sliderWrapper) return;
    const slides = sliderUL.querySelectorAll('.slider__slide');
    if (!slides.length) return;
    const desktopColumns = Number(sliderUL.className.match(/grid--(\d+)-col-desktop/)?.[1] || 1);
    let dotsContainer = sectionRoot.querySelector('.custom-slider-dots');
    if (!dotsContainer) {
      dotsContainer = document.createElement('div');
      dotsContainer.className = 'custom-slider-dots';
      sliderWrapper.after(dotsContainer);
    }
    function buildDots() {
      dotsContainer.innerHTML = "";
      const dotsCount = window.innerWidth >= 990 ? Math.ceil(slides.length / desktopColumns) : slides.length;
      for (let i = 0; i < dotsCount; i++) {
        const dot = document.createElement("button");
        dot.className = "dot-item";
        dot.dataset.index = i;
        dot.setAttribute("aria-label", "slider-dot");
        dotsContainer.appendChild(dot);
      }
      dotsContainer.querySelector(".dot-item")?.classList.add("active");
    }
    buildDots();
    window.addEventListener("resize", buildDots);
    function updateDots(activeIndex) {
      dotsContainer.querySelectorAll('.dot-item').forEach((dot, i) => dot.classList.toggle("active", i === activeIndex));
    }
    dotsContainer.addEventListener("click", e => {
      if (!e.target.classList.contains("dot-item")) return;
      const index = Number(e.target.dataset.index);
      const scrollToIndex = window.innerWidth >= 990 ? index * desktopColumns : index;
      sliderWrapper.scrollTo({ left: slides[0].clientWidth * scrollToIndex, behavior: "smooth" });
    });
    sliderWrapper.addEventListener("scroll", () => {
      const w = slides[0].clientWidth;
      const activeIndex = window.innerWidth >= 990
        ? Math.round(sliderWrapper.scrollLeft / (w * desktopColumns))
        : Math.round(sliderWrapper.scrollLeft / w);
      updateDots(activeIndex);
    });
  });

  // ── 7. Featured Collection Dots ─────────────────
  document.querySelectorAll('.featured-collection [id^="Slider-"]').forEach(sliderUL => {
    const sectionRoot = sliderUL.closest('.featured-collection');
    const sliderWrapper = sliderUL.closest('.slider');
    if (!sectionRoot || !sliderWrapper) return;
    const slides = sliderUL.querySelectorAll('.slider__slide');
    if (!slides.length) return;
    const desktopColumns = Number(sliderUL.className.match(/grid--(\d+)-col-desktop/)?.[1] || 1);
    let dotsContainer = sectionRoot.querySelector('.custom-fc-slider-dots');
    if (!dotsContainer) {
      dotsContainer = document.createElement('div');
      dotsContainer.className = 'custom-fc-slider-dots';
      sliderWrapper.after(dotsContainer);
    }
    function buildDots() {
      dotsContainer.innerHTML = "";
      const dotsCount = window.innerWidth >= 990 ? Math.ceil(slides.length / desktopColumns) : slides.length;
      for (let i = 0; i < dotsCount; i++) {
        const dot = document.createElement("button");
        dot.className = "fc-dot-item";
        dot.dataset.index = i;
        dotsContainer.appendChild(dot);
      }
      dotsContainer.querySelector(".fc-dot-item")?.classList.add("active");
    }
    buildDots();
    window.addEventListener("resize", buildDots);
    function updateDots(activeIndex) {
      dotsContainer.querySelectorAll('.fc-dot-item').forEach((dot, i) => dot.classList.toggle("active", i === activeIndex));
    }
    dotsContainer.addEventListener("click", e => {
      if (!e.target.classList.contains("fc-dot-item")) return;
      const index = Number(e.target.dataset.index);
      const scrollToIndex = window.innerWidth >= 990 ? index * desktopColumns : index;
      sliderWrapper.scrollTo({ left: slides[0].clientWidth * scrollToIndex, behavior: "smooth" });
    });
    sliderWrapper.addEventListener("scroll", () => {
      const w = slides[0].clientWidth;
      const activeIndex = window.innerWidth >= 990
        ? Math.round(sliderWrapper.scrollLeft / (w * desktopColumns))
        : Math.round(sliderWrapper.scrollLeft / w);
      updateDots(activeIndex);
    });
  });

  // ── 8. Slider Drag + Pagination ─────────────────
  document.querySelectorAll("slider-component .slider").forEach(slider => {
    if (window.innerWidth < 768) {
      let isDown = false, startX, scrollLeft;
      slider.addEventListener("mousedown", e => { isDown = true; startX = e.pageX - slider.offsetLeft; scrollLeft = slider.scrollLeft; slider.classList.add("is-dragging"); });
      slider.addEventListener("mouseleave", () => { isDown = false; slider.classList.remove("is-dragging"); });
      slider.addEventListener("mouseup", () => { isDown = false; slider.classList.remove("is-dragging"); });
      slider.addEventListener("mousemove", e => { if (!isDown) return; e.preventDefault(); slider.scrollLeft = scrollLeft - (e.pageX - slider.offsetLeft - startX) * 1.5; });
    }
    const slides = slider.querySelectorAll(".grid__item");
    const paginationContainer = document.getElementById(slider.getAttribute("id").replace("Slider-", "Pagination-"));
    if (!paginationContainer || !slides.length) return;
    const itemsPerPage = Math.round(slider.clientWidth / slides[0].offsetWidth);
    const totalPages = Math.ceil(slides.length / itemsPerPage);
    paginationContainer.innerHTML = "";
    for (let i = 0; i < totalPages; i++) {
      const dot = document.createElement("span");
      dot.className = "slider-dot" + (i === 0 ? " active" : "");
      dot.addEventListener("click", () => slider.scrollTo({ left: i * slider.clientWidth, behavior: "smooth" }));
      paginationContainer.appendChild(dot);
    }
    const dots = paginationContainer.querySelectorAll(".slider-dot");
    slider.addEventListener("scroll", () => {
      const currentIndex = Math.round(slider.scrollLeft / slider.clientWidth);
      dots.forEach((dot, i) => dot.classList.toggle("active", i === currentIndex));
    });
  });

  // ── 9. Review & FAQ Tabs ────────────────────────
  const reviewWidget = document.querySelector("#judgeme_product_reviews");
  if (reviewWidget) {
    const faqWidget = document.querySelector(".custom-product-faq");
    if (faqWidget) reviewWidget.parentNode.appendChild(faqWidget);
    const reviewsBtn = document.createElement("button");
    reviewsBtn.innerText = "Review";
    reviewsBtn.className = "rf-tab-btn rf-tab-review active";
    reviewWidget.parentNode.insertBefore(reviewsBtn, reviewWidget);
    if (faqWidget && faqWidget.innerHTML.trim() !== "") {
      const faqBtn = document.createElement("button");
      faqBtn.innerText = "Frequently Asked Questions";
      faqBtn.className = "rf-tab-btn rf-tab-faq";
      reviewWidget.parentNode.insertBefore(faqBtn, reviewWidget);
      reviewWidget.style.display = "block";
      faqWidget.style.display = "none";
      reviewsBtn.addEventListener("click", () => { reviewWidget.style.display = "block"; faqWidget.style.display = "none"; reviewsBtn.classList.add("active"); faqBtn.classList.remove("active"); });
      faqBtn.addEventListener("click", () => { reviewWidget.style.display = "none"; faqWidget.style.display = "block"; faqBtn.classList.add("active"); reviewsBtn.classList.remove("active"); });
    } else {
      reviewWidget.style.display = "block";
    }
  }

  // ── 10. Cart Layout ─────────────────────────────
  const itemsSection = document.querySelector('#main-cart-items');
  const footerSection = document.querySelector('#main-cart-footer');
  if (itemsSection && footerSection) {
    const wrapper = document.createElement('div');
    wrapper.className = 'cart-flex-wrap';
    itemsSection.parentNode.insertBefore(wrapper, itemsSection);
    wrapper.appendChild(itemsSection);
    wrapper.appendChild(footerSection);
  }

});
